module.exports = __webpack_public_path__ + "img/justine_wichmann_7.31472b36.jpg";